export const pxToRem = (px: number, base: number = 16): string => {
  return `${px / base}rem`;
};
const lightenColor = (hex: any, percent: any) => {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char: any) => char + char)
      .join("");
  }

  if (hex.length !== 6) return null;

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const lighten = (value: any) =>
    Math.min(255, Math.floor(value + (255 - value) * (percent / 100)));

  const newR = lighten(r);
  const newG = lighten(g);
  const newB = lighten(b);

  return `rgb(${newR}, ${newG}, ${newB})`;
};
export const changeColor = (theme: any) => {
  const buttonHover = lightenColor(theme?.button?.color, 80);
  document.documentElement.style.setProperty(
    "--primary-color",
    theme?.primarycolor
  );
  document.documentElement.style.setProperty(
    "--secondary-color",
    theme?.secondarycolor
  );
  document.documentElement.style.setProperty(
    "--button-gradient-color",
    theme?.button?.gradientcolor
  );
  document.documentElement.style.setProperty(
    "--button-color",
    theme?.button?.color
  );
  document.documentElement.style.setProperty(
    "--button-light-color",
    buttonHover
  );
};
